import { useCallback } from 'react';
import { confirm, presign, uploadToS3, validateImageFile, type MediaCategory } from '@/lib/upload';

/** 정보성 메일 본문 이미지 — 전용 카테고리가 없어 MISC(공개 URL). 메일 클라이언트가 이 주소로 이미지를 불러온다. */
const EMAIL_IMAGE_CATEGORY: MediaCategory = 'MISC';

/**
 * QA-419 — 정보성 메일 에디터(RichTextEditor onUploadImage)용 업로드. presign → S3 PUT → confirm 으로
 * 공개 URL 을 돌려준다(홈 팝업 본문 업로드와 같은 흐름). 이미지는 메일에 첨부되는 것이 아니라 본문에 링크된다.
 */
export const useEmailImageUpload = (): ((file: File) => Promise<string>) =>
  useCallback(async (file: File): Promise<string> => {
    const validationError = validateImageFile(file);
    if (validationError) throw new Error(validationError);
    const [slot] = await presign([{ file, category: EMAIL_IMAGE_CATEGORY }]);
    if (!slot) throw new Error('업로드 URL 발급 응답이 올바르지 않습니다.');
    await uploadToS3([{ item: slot, file }]);
    const confirmed = await confirm([slot.fileId]);
    const publicUrl = confirmed.get(slot.fileId) ?? slot.publicUrl;
    if (!publicUrl) throw new Error('업로드한 이미지 주소를 확인하지 못했습니다.');
    return publicUrl;
  }, []);
